import { UPDATE_SCHEDULE_REMINDER } from 'apollo/mutations/schedule-reminder-mutations';
import { useApolloUpdate } from 'hooks';
import { IScheduleReminder } from 'types/ScheduleReminder';
import { ScheduleReminderUpdateInput } from '__generated__/graphql';

interface IScheduleReminderUpdateResult {
  updateScheduleReminder: IScheduleReminder[];
}

export default function useScheduleReminderUpdate() {
  return useApolloUpdate<ScheduleReminderUpdateInput, IScheduleReminderUpdateResult>(
    UPDATE_SCHEDULE_REMINDER,
    'reminder'
  );
}
